import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppWrapper } from './AppWrapper';
import App from './components/App';

function PriviaApp() {
  return (
    <AppWrapper>
      <App />
    </AppWrapper>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<PriviaApp />);
